module.exports = __webpack_public_path__ + "img/xhy.red-150x150.e6938993.png";